module.exports = __webpack_public_path__ + "static/media/timeNew.6de1f9a7.svg";